import { React } from 'react';

import $ from 'jquery';

import style from './culture.module.scss';

let ImageHome = process.env.PUBLIC_URL + '/assets/image/home';

export const Culture = () => {
    function mouseEnter(id) {
        let img = $(`#${id}`).first();
        img.attr('src', ImageHome + '/' + id + '-fill.svg');
    }

    function mouseLeave(id) {
        let img = $(`#${id}`);
        img.attr('src', ImageHome + '/' + id + '.svg');
    }

    return (
        <div className={style.culture}>
            <div className={style.cultureTitle}>
                <div>Our Culture</div>
            </div>

            <div className={style.cultureList}>
                <div
                    className={style.cultureItem}
                    onMouseEnter={(e) => {
                        mouseEnter('trusted');
                    }}
                    onMouseLeave={(e) => {
                        mouseLeave('trusted');
                    }}
                >
                    <div className={style.cultureBanner}>
                        <img alt="" className={style.cultureLogo} id="trusted" src={ImageHome + '/trusted.svg'}></img>
                        <div className={style.cultureBannerText}>TRUSTED</div>
                    </div>

                    <hr className={style.splitLine}></hr>

                    <div className={style.cultureTextContent}>
                        Our customers engage us as a trusted partner to source critical system components made from
                        high-quality precision-molded rubber.
                    </div>
                </div>

                <div
                    className={style.cultureItem}
                    onMouseEnter={(e) => {
                        mouseEnter('reliable');
                    }}
                    onMouseLeave={(e) => {
                        mouseLeave('reliable');
                    }}
                >
                    <div className={style.cultureBanner}>
                        <img alt="" className={style.cultureLogo} id="reliable" src={ImageHome + '/reliable.svg'}></img>
                        <div className={style.cultureBannerText}>RELIABLE</div>
                    </div>

                    <hr className={style.splitLine}></hr>

                    <div className={style.cultureTextContent}>
                        Our proprietary, fully vetted, reliable network of resources offers unmatched quality,
                        production timeliness, and cost-effective solutions.
                    </div>
                </div>

                <div
                    className={style.cultureItem}
                    onMouseEnter={(e) => {
                        mouseEnter('service');
                    }}
                    onMouseLeave={(e) => {
                        mouseLeave('service');
                    }}
                >
                    <div className={style.cultureBanner}>
                        <img alt="" className={style.cultureLogo} id="service" src={ImageHome + '/service.svg'}></img>
                        <div className={style.cultureBannerText}>SERVICE</div>
                    </div>

                    <hr className={style.splitLine}></hr>

                    <div className={style.cultureTextContent}>
                        Our proactive approach, extensive experience, and customer-first service delivers exceptional
                        value that is unparalleled in the marketplace.
                    </div>
                </div>

                <div
                    className={style.cultureItem}
                    onMouseEnter={(e) => {
                        mouseEnter('value');
                    }}
                    onMouseLeave={(e) => {
                        mouseLeave('value');
                    }}
                >
                    <div className={style.cultureBanner}>
                        <img alt="" className={style.cultureLogo} id="value" src={ImageHome + '/value.svg'}></img>
                        <div className={style.cultureBannerText}>VALUE</div>
                    </div>

                    <hr className={style.splitLine}></hr>

                    <div className={style.cultureTextContent}>
                        Value is more important than cost at Wintech seals. A poorly sourced part at a lower price isn't
                        always the better choice, it is often a costly one, causing clients delays and potential project
                        failures. The Wintech experience is better than a low price; we ensure that we are
                        recommending/sourcing the right part for your project, every time.
                    </div>
                </div>
            </div>
        </div>
    );
};
